<template lang="pug">
.v-main-slider.main-slider(v-if="slider")
	.main-slider__container.container

		.main-slider__wrap
			button.main-slider__arrow.main-slider__arrow--prev(type="button" ref="prev" aria-label="Предыдущий слайд")
				v-svg-icon.main-slider__arrow-icon(icon="slide-left")
				v-svg-icon.main-slider__arrow-bg(icon="slide-left-bg")
			button.main-slider__arrow.main-slider__arrow--next(type="button" ref="next" aria-label="Следующий слайд")
				v-svg-icon.main-slider__arrow-icon(icon="slide-right")
				v-svg-icon.main-slider__arrow-bg(icon="slide-right-bg")
			.main-slider__inner
				template(v-if="isMd && originalItems && originalItems.length")
					v-swiper-slider(:options="optionsMob"
							:navigation="navigation"
							:pagination="pagination"
							allow-touch-move)
						swiper-slide.main-slider__swiper-slide(v-for="(item, index) in originalItems" :key="index")
							component.main-slider__slide(:style="{'background': item.background}" :href="isSm ? null : item.link" :is="isSm ? 'div' : 'a'")
								a.main-slider__cover-link(v-if="isSm" :href="item.link")
								h2.main-slider__slide-text {{item.title}}
								.main-slider__slide-small-text(v-if="item.text && !isSm") {{item.text}}
								.main-slider__slide-small-text(v-if="item.textMob && isSm") {{item.textMob}}
								.main-slider__slide-action(v-if="item.button")
									.main-slider__slide-action-btn(:class="item.button.className ? item.button.className : 'btn'") {{item.button.text}}
								template(v-if="isSm && $slots['search']")
									.main-slider__search
										slot(name="search")
								img.main-slider__slide-image(v-if="item.image" :src="item.image" alt="")
				template(v-else-if="!isMd && items && items.length")
					v-swiper-slider(:options="options"
							:navigation="navigation"
							:pagination="pagination"
							effect="cards"
							:cards-effect="cardsEffect"
							allow-touch-move
							@swiper="onSwiper")
						swiper-slide.main-slider__swiper-slide(v-for="(item, index) in items" :key="index")
							a.main-slider__slide(:style="{'background': item.background}" :href="item.link")
								h2.main-slider__slide-text {{item.title}}
								.main-slider__slide-small-text(v-if="item.text && !isSm") {{item.text}}
								.main-slider__slide-small-text(v-if="item.textMob && isSm") {{item.textMob}}
								.main-slider__slide-action(v-if="item.button")
									.main-slider__slide-action-btn(:class="item.button.className ? item.button.className : 'btn'") {{item.button.text}}
								img.main-slider__slide-image(v-if="item.image" :src="item.image" alt="")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import uniqueId from '../scripts/helpers/uniqueId.js';
import {SwiperSlide} from 'swiper/vue';

export default {
	components: {
		SwiperSlide
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			slider: null,
			items: null,
			originalItems: null,
			uniqueId: uniqueId('swiper-'),
			uniqueId2: uniqueId('swiper-'),
			options: null,
			optionsMob: null,
			cardsEffect: {
				perSlideOffset: 49,
				slideShadows: true,
				rotate: false
			},
			navigation: false,
			pagination: {
				clickable: false
			}
		};
	},

	methods: {
		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		dataSet(data) {
			this.slider = data;
			this.originalItems = data.items;
			this.items = JSON.parse(JSON.stringify(this.originalItems));
			let lastItem = this.items[data.items.length - 1];
			this.items.splice(0, 0, lastItem);
			this.options = {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: false,
				initialSlide: 1
			};
			this.optionsMob = {
				slidesPerView: 1,
				spaceBetween: 8,
				loop: true,
				initialSlide: 0
			};
			this.uniqueId = uniqueId('swiper-');
			this.uniqueId2 = uniqueId('swiper-');
		}
	}
};
</script>